/** Created by azhou on 2019/2/15.*/
<template>
  <div class="d-center">
    <span :class="[required ? 'text-danger':'text-white','mr-small']">*</span>
    <div class="form-left-text">{{leftText}}</div><span class="text-dls">：</span>
    <div class="option-wrap " :class="[checkbox ? 'checkbox-group':'checkbox-nrls']">
      <el-checkbox-group class="group " v-model="valueInside" @change="onChange" >
        <el-checkbox  v-for="item in options"
          :key="item.id"
          :label="item.id"
          :value="item.id">{{item.name}}</el-checkbox>
      </el-checkbox-group>      
    </div>
  </div>
</template>

<script>
export default {
  name: "LeftTextRadio",
  props: {
    value: {},
    leftText: {
      type: String
    },
    placeholder: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    checkbox: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      valueInside: []
    };
  },

  mounted() {
    if (this.value) {
      if (this.value instanceof Array) {
        this.valueInside = this.value;
      } else {
        this.valueInside = this.value.split(",");
      }
    }
  },
  watch: {
    value(nval) {
      if (nval) {
        if (nval instanceof Array) {
          this.valueInside = nval;
        } else {
          this.valueInside = nval.split(",");
        }
      }
    }
  },
  methods: {
    onChange() {
      if (this.value instanceof Array) {
        this.$emit("input", this.valueInside);
      } else {
        this.$emit("input", this.valueInside.join(","));
      }
    }
  }
};
</script>


<style scoped lang="scss">
.d-center {
  justify-content: inherit;
  align-items: flex-start;
  line-height: 10px;
}
.option-wrap {
  flex: 1;
  .group {
    display: flex;
    flex-wrap: wrap;
  }
  ::v-deep .el-checkbox {
    margin-bottom: 7px;
  }  
}
</style>
<style>
.checkbox-group .el-checkbox__label{
  min-width: 100px !important;
  display: inline-block;
  text-align: left;
}
.checkbox-nrls .el-checkbox__label{
  min-width: 70px !important;
  display: inline-block;
  text-align: left;
}
</style>
